<!-- <nb-card>
    <nb-card-header>Edit Navigation Tree for: {{item?.title}}</nb-card-header>
    <nb-card-body>
        <ng-container *ngIf="isLoaded">
            <db-angular-tree-grid #angularGrid [data]="data || []" [configs]="configs" kveTreeGridStyler (add)="onAdd($event)"></db-angular-tree-grid>
        </ng-container>
    </nb-card-body>
    <nb-card-footer>
        <div class="footer-content">
            <div class="footer-info">Expand items to see children</div>
            <button nbButton size="tiny">Close</button>
        </div>
    </nb-card-footer>
</nb-card> -->
<p>Block is uncommented cause an error 8001 error nb-card not a known element</p>
